// extracted by mini-css-extract-plugin
export default {"root":"styles_root__KSg0T","button":"styles_button__bihpB"};